import { IconArrowRight } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink, useLocation } from 'react-router';

function Sidebar({ items }) {
  const location = useLocation();

  return (
    <div className="sidebar">
      {items.map((item, index) => (
        <NavLink
          key={index}
          to={item.path}
          style={{ textDecoration: 'none' }}
          className={({ isActive }) =>
            `tab-btn ${index === items.length - 1 ? 'mb-0' : ''} ${
              isActive ||
              (item.matchSubpaths && location.pathname.startsWith(item.path))
                ? 'active'
                : ''
            }`
          }
        >
          <div className="tab-label">
            {item.icon}
            {item.label}
          </div>
          <IconArrowRight size={24} className="right-arrow me-0" />
        </NavLink>
      ))}
    </div>
  );
}

Sidebar.propTypes = {
  items: PropTypes.array,
};

export default Sidebar;
